import React from 'react'
import { Badge } from '@/components/ui/badge'
import { X } from 'lucide-react'
import { cn } from '@/lib/utils'
import { FilterDisplayItem } from '@/utils/filterUtils'

interface FilterBadgeProps {
  item: FilterDisplayItem
  index: number
  showRemove?: boolean
  maxWidth?: string
  size?: 'sm' | 'md'
}

const FilterBadge: React.FC<FilterBadgeProps> = ({
  item,
  showRemove = false,
  maxWidth = 'max-w-[200px]',
  size = 'md',
}) => {
  const paddingClass = size === 'sm' ? 'px-2 py-0.5' : 'px-2.5 py-1.5'
  const gapClass = size === 'sm' ? 'gap-1' : 'gap-1.5'
  const roundedClass = size === 'sm' ? 'rounded-md' : 'rounded-lg'

  return (
    <Badge
      variant='outline'
      className={cn(
        'inline-flex items-center',
        gapClass,
        paddingClass,
        roundedClass,
        'text-xs font-medium transition-all duration-200',
        'cursor-default',
        item.colorClass
      )}
    >
      <span className='flex-shrink-0'>{item.icon}</span>
      <span className={cn('truncate', maxWidth)}>{item.label}</span>
      {showRemove && item.onRemove && (
        <button
          type='button'
          onClick={item.onRemove}
          className={cn(
            'flex-shrink-0 ml-0.5 rounded-full p-0.5',
            'transition-colors duration-150',
            'hover:bg-black/10 focus:outline-none focus:ring-2 focus:ring-offset-1',
            'focus:ring-current'
          )}
          aria-label={`Remove ${item.label}`}
        >
          <X className='h-3 w-3' />
        </button>
      )}
    </Badge>
  )
}

export default FilterBadge
